var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-center bg-cover page-title-header bg-primary",class:_vm.imgClasses,style:(_vm.bgImageStyle)},[_vm._t("default",[_vm._v("Title Header")],{"pageAccessor":_vm.pageAccessor})],2)}
var staticRenderFns = []

export { render, staticRenderFns }